// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1PlTh","buttons":"PendingPaymentAlert_buttons__qL8h7"};